import {Injectable} from '@angular/core';


@Injectable()
export class ClipsService {
  constructor() {
  }

  async createClip(streamKey: string) {
    window.open('https://goodgame.ru/clip/creating?src=' + streamKey);
    return true;
  }

}
